module.exports = __webpack_public_path__ + "img/categories_nav.b735c214.svg";